export default __webpack_public_path__ + "static/media/prepare-tile.0b84d6c1.svg";